import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function UserCheckIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Union" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M4.09022 4.91992c-1.95111 0 -3.803303 1.40355 -3.570338 3.34071 0.018099 0.1505 0.039704 0.3084 0.064802 0.47636 0.074684 0.49981 0.510516 0.86295 1.015886 0.86295h0.57767l0.42146 2.61656c0.11913 0.7396 0.75754 1.2834 1.50673 1.2834 0.74919 0 1.3876 -0.5438 1.50674 -1.2834l0.42145 -2.61656h0.58511c0.50206 0 0.93662 -0.35823 1.01322 -0.85442 0.02448 -0.15853 0.04552 -0.30826 0.0631 -0.45182 0.23897 -1.95097 -1.64028 -3.37378 -3.60583 -3.37378Z"
          strokeWidth="1"></path>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M4.10808 4.66001c1.33121 0 2.08001 -0.7488 2.08001 -2.08C6.18809 1.2488 5.43929 0.5 4.10808 0.5c-1.3312 0 -2.08 0.7488 -2.08 2.08001 0 1.3312 0.7488 2.08 2.08 2.08Z"
          strokeWidth="1"></path>
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M9 11.8125 10.6364 13.5c0.77 -2.2119 1.4113 -3.1825 2.8636 -4.5" strokeWidth="1"></path>
  </SvgIcon>
}